"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPanelView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const StoreNavComponents_1 = require("./StoreNavComponents");
const __1 = require("../..");
const Panel = app_1.styled.div `
  height: 4.5625rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${(theme) => theme.spacing.extraSmall};
`;
const ActionButton = (0, app_1.styled)(ui_1.Button) `
  color: inherit;
`;
const StyledInput = (0, app_1.styled)(__1.SearchInput.Input) `
  border: 0;
`;
function SearchPanel({ closePanel }) {
    const { t } = (0, app_1.useTranslation)();
    const scrollLockRef = (0, app_1.useScrollLock)();
    const { query } = (0, app_1.useRouter)();
    const [inputEmpty, setInputEmpty] = (0, react_1.useState)(true);
    const handleInput = (val) => {
        if (val === '') {
            setInputEmpty(true);
        }
        else if (inputEmpty) {
            setInputEmpty(false);
        }
        return val;
    };
    return ((0, jsx_runtime_1.jsx)(Panel, Object.assign({ onClick: (e) => e.stopPropagation(), ref: scrollLockRef }, { children: (0, jsx_runtime_1.jsx)(__1.SearchInput.Form, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_1.FormContext, { children: ({ setValue }) => ((0, jsx_runtime_1.jsx)(StyledInput, { withoutSearchIcon: true, setValue: setValue, defaultValue: query === null || query === void 0 ? void 0 : query.search, name: "search", onChange: handleInput, placeholder: t('label.searchPlaceholder'), containerCss: (0, app_1.css) `
                  width: 100%;
                ` })) }), (0, jsx_runtime_1.jsx)(ActionButton, Object.assign({ kind: ['icon', 'transparent'], type: inputEmpty ? 'button' : 'submit', href: undefined, onClick: inputEmpty ? closePanel : undefined }, { children: inputEmpty ? (0, jsx_runtime_1.jsx)(svg_1.SvgCloseMenu, {}) : (0, jsx_runtime_1.jsx)(svg_1.SvgSearch, {}) }))] }) }) })));
}
function SearchPanelView() {
    const [{ searchPanelOpen }, dispatch] = (0, __1.useUi)('searchPanelOpen');
    const closePanel = (0, react_1.useCallback)(() => dispatch('CLOSE_SEARCH_PANEL'), [dispatch]);
    return ((0, jsx_runtime_1.jsx)(ui_1.Animation, Object.assign({ type: "opacity" }, { children: searchPanelOpen && ((0, jsx_runtime_1.jsx)(StoreNavComponents_1.Backdrop, Object.assign({ "$open": true, onClick: closePanel }, { children: (0, jsx_runtime_1.jsx)(SearchPanel, { closePanel: closePanel }) }))) })));
}
exports.SearchPanelView = SearchPanelView;
